import http from "@/http/aisea/axios";
const resource = "/enterprises/manning/statuses";

/**
 * 法人勤務種別リポジトリ
 */
export default {
  /**
   * 法人勤務種別一覧取得
   * @returns
   */
  fetch() {
    return http.get(`${resource}`);
  },
};
